// extracted by mini-css-extract-plugin
module.exports = {"inlineRecircPlaceholder":"inlineRecirc_inlineRecircPlaceholder__j77qU","inlineRecirc":"inlineRecirc_inlineRecirc___tXlc"};